import React from 'react'
import clsx from 'classnames'
import type { ServiceGroup } from 'src/store/data.store'
import { formatPriceForSalon } from 'utils/formatPrice'
import styles from './ServiceOptions.module.scss'

type ServiceOptionsProps = {
  options: ServiceGroup['options'],
  activeIndex: number,
  onChange: (index: number) => void,
  salonId?: number | null,
  className?: string,
}

/** Option chips of a service page (title and price); nothing when there is only one option */
export const ServiceOptions: React.FC<ServiceOptionsProps> = (props) => {
  const { options, activeIndex, onChange, salonId, className } = props
  if (options.length < 2) {
    return null
  }
  return (
    <div className={clsx([styles.options, className])} role={'radiogroup'}>
      {options.map((option, idx) => (
        <button
          key={option.service.id}
          type={'button'}
          role={'radio'}
          aria-checked={activeIndex === idx}
          className={clsx([styles.option, { [styles.active]: activeIndex === idx }])}
          onClick={(e) => {
            e.stopPropagation()
            onChange(idx)
          }}
        >
          <span className={styles.optionTitle}>{option.title}</span>
          <span className={styles.optionPrice}>{formatPriceForSalon(option.service, salonId)}&nbsp;₽</span>
        </button>
      ))}
    </div>
  )
}
